import React from "react";
import { SvgIcon } from "@mui/material";
import styles from "./iconStyles";

function People() {
  return (
    <SvgIcon style={styles.icon}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_2177_13790)">
          <path
            d="M16.6699 13.1309C18.0399 14.0609 18.9999 15.3209 18.9999 17.0009V20.0009H22.9999V17.0009C22.9999 14.8209 19.4299 13.5309 16.6699 13.1309Z"
            fill="#C7C9CD"
          />
          <path
            d="M14.9999 12C17.2099 12 18.9999 10.21 18.9999 8C18.9999 5.79 17.2099 4 14.9999 4C14.5299 4 14.0899 4.1 13.6699 4.24C14.4999 5.27 14.9999 6.58 14.9999 8C14.9999 9.42 14.4999 10.73 13.6699 11.76C14.0899 11.9 14.5299 12 14.9999 12Z"
            fill="#C7C9CD"
          />
          <path
            d="M9 12C11.21 12 13 10.21 13 8C13 5.79 11.21 4 9 4C6.79 4 5 5.79 5 8C5 10.21 6.79 12 9 12ZM9 6C10.1 6 11 6.9 11 8C11 9.1 10.1 10 9 10C7.9 10 7 9.1 7 8C7 6.9 7.9 6 9 6Z"
            fill="#747881"
          />
          <path
            d="M9 13C6.33 13 1 14.34 1 17V20H17V17C17 14.34 11.67 13 9 13ZM15 18H3V17.01C3.2 16.29 6.3 15 9 15C11.7 15 14.8 16.29 15 17V18Z"
            fill="#747881"
          />
        </g>
        <defs>
          <clipPath id="clip0_2177_13790">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
}

export default People;
